import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import { RAILWAY_API } from "../config";
import { mapRailwayStations, mapRailwayStops, mapRailwayTickets } from "../api/adapters";
import type { RailwayStationsRaw, RailwayStopsRaw, RailwayTicketsRaw } from "../api/adapters";
import type { RailwayQuery, RailwayStationsData, RailwayStopsData, RailwayTicketsData } from "../types";

/** 获取车站字典与当前开放查询日期。 */
export async function fetchStations(signal?: AbortSignal): Promise<RailwayStationsData> {
  const response = await httpClient.get<ApiEnvelope<RailwayStationsRaw>>(`${RAILWAY_API}/stations`, { signal, timeout: 45_000, "axios-retry": { retries: 0 } });
  return mapRailwayStations(requireData(response.data));
}

/** 查询真实车次与票价，不自动重复上游请求。 */
export async function fetchTickets(query: RailwayQuery, signal?: AbortSignal): Promise<RailwayTicketsData> {
  const response = await httpClient.get<ApiEnvelope<RailwayTicketsRaw>>(`${RAILWAY_API}/tickets`, { params: query, signal, timeout: 45_000, "axios-retry": { retries: 0 } });
  return mapRailwayTickets(requireData(response.data));
}

/** 获取所选车次沿途停站。 */
export async function fetchStops(query: Omit<RailwayQuery, "purpose"> & { train_no: string }, signal?: AbortSignal): Promise<RailwayStopsData> {
  const response = await httpClient.get<ApiEnvelope<RailwayStopsRaw>>(`${RAILWAY_API}/stops`, { params: query, signal, timeout: 45_000, "axios-retry": { retries: 0 } });
  return mapRailwayStops(requireData(response.data));
}

/** 缺失数据不能伪装成查询成功且无车次。 */
function requireData<T>(envelope: ApiEnvelope<T>): T {
  if (envelope.code !== "OK" || envelope.data == null) throw new Error("铁路查询接口没有返回有效数据，请重试");
  return envelope.data;
}
